export const requestResetTitleText = `New Password`;
export const passwordSubtitleText = `Enter your email and we will send you a reset link.`;
